// The file system blocks these prefixes for every caller, so the explorer never shows them
export const HIDDEN_PREFIXES = ["temp/claims/"]

export const isHiddenKey = key => typeof key === "string" && HIDDEN_PREFIXES.some(prefix => key.startsWith(prefix))

export const withoutHidden = ({ commonPrefixes = [], objectSummaries = [] }) => ({
	commonPrefixes: commonPrefixes.filter(path => !isHiddenKey(path)),
	objectSummaries: objectSummaries.filter(item => !isHiddenKey(item?.key)),
})
